module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#arrow",
      toString: function () {
        return this.url;
      }
    }